
/*
 * 所有弹窗右上角的 close 按钮
 * 引入的父级需要有 position 属性
 */

import React from 'react';
import SVGPureIcon from "@ui/svg-icon";

export default function ModalClose(props) {
  const {
    width = 16,
    height = 16,
    style,
    onClose = evt => { } // 暂未用到，用的 modal 的自定义 closeIcon
  } = props;
  
  return (
    <div style={{
      width,
      height,
      ...style,
    }} className="cursor-pointer group" onClick={onClose} >
      <SVGPureIcon name="modal_close" className="text-primary-opacity text-opacity-50 hover:text-opacity-100" />
    </div >
  );
};

